<template>
  <div id="app">
    <template v-if="isLoginPage">
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="app-layout">
        <Sidebar />
        <div class="main-content ml200">
          <Header />
          <div class="page-content">
            <router-view></router-view>
          </div>
          <div class="app-footer">
            <div class="footer-content">
              <span>© 2026 上海巡山客户外运动有限公司 版权所有</span>
              <span class="divider">|</span>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                沪ICP备2026021332号
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Sidebar from './components/Sidebar.vue'
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Sidebar,
    Header
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/login'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  color: #333;
  background-color: #f5f7fa;
}

#app {
  min-height: 100vh;
}

.app-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.ml200 {
  margin-left: 200px;
}
.page-content {
  flex: 1;
  padding: 60px 20px 20px 20px;
  background-color: #f5f7fa;
}

.app-footer {
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 16px 20px;
  text-align: center;
}

.footer-content {
  font-size: 12px;
  color: #9ca3af;
}

.footer-content .divider {
  margin: 0 8px;
  color: #e5e7eb;
}

.footer-content a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-content a:hover {
  color: #22c55e;
}
</style>
